/**
 * Build a short location suffix for jurisdiction filter/option labels.
 * Uses county and state when both or either are present; otherwise the name alone.
 */
export function jurisdictionOptionLabel(j: {
  name: string;
  county?: string | null;
  state?: string | null;
}): string {
  const place = [j.county, j.state].filter(Boolean).join(", ");
  return place ? `${j.name} (${place})` : j.name;
}
